module.exports = __webpack_public_path__ + "img/btn_cancel3_careers.af1b1255.png";